import React from "react";

import { Card, Col, Container, Image, Row } from "react-bootstrap";

import BannerComponent from "@/components/Banner.component";
import { trackEvent } from "@/components/GA.component";

import useContactContext from "../../hooks/useContactContext";
import i18n from "../../i18n";

import type { ContactCategory } from "@/context/ContactProvider.context";

interface Category {
  title: string;
  subtitle?: string;
  type: ContactCategory;
}

const ContactCategoryList = (): React.JSX.Element | null => {
  const { t } = i18n;
  const { setCategory, category } = useContactContext();

  if (category) {
    return null;
  }

  const handleCategoryClick = (value: ContactCategory) => {
    setCategory(value);
    trackEvent("contact_us_click_category", {
      category: value,
    });
  };

  const categories: Category[] = [
    {
      title: t("Affordable Housing Providers"),
      subtitle: t("Non-profits, municipalities, real estate developers"),
      type: "affordable",
    },
    {
      title: t("Builders & Contractors"),
      subtitle: t(
        "Housing/cottage builders, modular home builders, general contractors",
      ),
      type: "builders",
    },
    {
      title: t("Homeowners / End Clients"),
      subtitle: t("Individuals looking to build or buy"),
      type: "homeowners",
    },
    {
      title: t("Investors"),
      subtitle: t("Discover partnership and funding opportunities"),
      type: "investors",
    },
  ];

  return (
    <React.Fragment>
      <BannerComponent
        description={t("contact_us_description")}
        title={t("Contact Us")}
      />
      <Container className="d-flex flex-column justify-content-start align-items-start gap-5 h-100">
        <Image
          alt={t("Contact Us")}
          className="rounded contactUsImage d-none d-lg-block"
          src="/images/customer_support.png"
        />
        <Row>
          {categories.map((categoryItem) => (
            <Col
              key={categoryItem.type}
              className="text-center mb-4"
              lg={6}
              role="button"
              xs={12}
            >
              <Card
                className="p-0 h-100 contact-card"
                onClick={() => handleCategoryClick(categoryItem.type)}
              >
                <Card.Body>
                  <Card.Title className="m-0">{categoryItem.title}</Card.Title>

                  {categoryItem.subtitle ? (
                    <Card.Text>{categoryItem.subtitle}</Card.Text>
                  ) : null}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default ContactCategoryList;
